import axios from 'axios';
import { API } from './constants';

/**
 * Fire-and-forget: record that the logged-in user clicked share/copy-link.
 * Never throws and never blocks the copy action itself.
 */
export function trackShareClick() {
  try {
    const token = localStorage.getItem('adminToken');
    if (!token) return;
    axios
      .post(`${API}/track/share-click`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {});
  } catch {
    // ignore
  }
}
